import Icon from "@chakra-ui/icon";
import React from "react";
export default function EditIcon({ height, width }: any | undefined) {
  return (
    <Icon
      height={height}
      width={width}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66406 13.3411L7.46022 13.3282L15.7459 5.12168C16.071 4.79652 16.25 4.36469 16.25 3.90533C16.25 3.44597 16.071 3.01414 15.7459 2.68898L14.3816 1.32467C13.7312 0.674341 12.5966 0.677782 11.9514 1.32209L3.66406 9.53032V13.3411ZM13.1652 2.54102L14.5321 3.90275L13.1583 5.26362L11.794 3.90017L13.1652 2.54102ZM5.3845 10.2477L10.5716 5.10964L11.9359 6.47395L6.74968 11.6103L5.3845 11.6146V10.2477Z"
        fill="#424360"
      />
      <path
        d="M1.94359 16.7707H13.9867C14.9355 16.7707 15.7071 15.9991 15.7071 15.0503V7.59388L13.9867 9.31433V15.0503H4.66016C4.6378 15.0503 4.61457 15.0589 4.59221 15.0589C4.56382 15.0589 4.53543 15.0511 4.50619 15.0503H1.94359V3.00719H7.83352L9.55396 1.28674H1.94359C0.994763 1.28674 0.223145 2.05836 0.223145 3.00719V15.0503C0.223145 15.9991 0.994763 16.7707 1.94359 16.7707Z"
        fill="#424360"
      />
    </Icon>
  );
}
